import request from '@/utils/request'
import { AxiosPromise } from 'axios'
export function orderDetail (orderNumber: string | string[]): AxiosPromise {
    return request({
        url: `/hd-api/os/h5/order/pay/detail/${orderNumber}`,
        method: 'get',
    })
}